var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "First Visits",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      subtitle: _vm.allLocations
                        ? "First Visits By Location"
                        : `${_vm.selectedLocation.name} First Visits`,
                      allLocations: _vm.allLocations,
                      locationOptions: "",
                      selectedLocation: _vm.selectedLocation,
                      filter: "",
                      dateRange: _vm.dateRange,
                      reportUrl: "/dashboard/reports/first-visits",
                      dateOptions: "upcoming, today, month, year, quarter",
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.firstVisits,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      search: _vm.search,
                      groupBy: _vm.allLocations ? "location" : null,
                    },
                    on: {
                      "current-items": function ($event) {
                        return _vm.collapse()
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `group.header`,
                          fn: function ({ group, items, isOpen, toggle }) {
                            return [
                              _c(
                                "th",
                                { attrs: { colspan: _vm.headers.length } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "flex justify-start align-center pa-2",
                                      attrs: { "no-gutters": "" },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-3",
                                          on: { click: toggle },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(isOpen ? "remove" : "add") +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "soli-grey text-subtitle-1 font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(group) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "soli-grey text-small",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        • " +
                                                _vm._s(items.length) +
                                                " First Visits\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "soli-grey text-small",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        •\n                                        " +
                                                _vm._s(
                                                  `${
                                                    _vm.meta.find(
                                                      (e) => e.location == group
                                                    )?.conversion
                                                  } Conversion`
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.student.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center py-2 soli-grey",
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    {
                                      staticClass: "my-0",
                                      staticStyle: { float: "left" },
                                    },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: item.student.profile_photo_url,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.student.id}/account`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(item.student.name) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.student.email) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.status`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "white--text font-bold",
                                  attrs: {
                                    small: "",
                                    color:
                                      item.status == "Lost"
                                        ? "soli-status-red"
                                        : item.status == "Enrolled"
                                        ? "soli-status-green"
                                        : "accent",
                                  },
                                },
                                [_vm._v(_vm._s(item.status))]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.starts_at`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "font-bold soli-grey" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        item.starts_at
                                          ? _vm.globalMomentDate(item.starts_at)
                                          : "No scheduled lessons"
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.teacher.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "Link",
                                {
                                  attrs: {
                                    href: `/profile/${item.teacher.id}/manage`,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.teacher.name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }